import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Container, Sidebar, Sidenav, Content, Nav, DOMHelper } from 'rsuite';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import NavToggle from './NavToggle';
import Header from '../Header';
import NavLink from '../NavLink';
import { useTranslation } from 'react-i18next';

import Logo from '../Logo';
// import Brand from '@/images/wpBrand.svg';
// import Brand from '@/images/logo_wp_blanc.svg';
import Brand from '@/images/wpBlanc.svg';

import { useAppSelector } from '@/config/hooks';
import {
  MdOutlineContactSupport,
  MdOutlineDashboard,
  MdOutlineSensorOccupied
} from 'react-icons/md';
import { FaChartLine, FaLayerGroup, FaRegBuilding, FaRegChartBar } from 'react-icons/fa';
import { Calendar, EventDetail, Icon, Location, Log } from '@rsuite/icons';
import { getRefreshToken, getToken } from '@/services/auth.service';
import { VscCalendar } from 'react-icons/vsc';
import {
  RiCalendarCloseLine,
  RiHomeOfficeLine,
  RiOrganizationChart,
  RiUserLocationLine
} from 'react-icons/ri';
import { TbBuildingCommunity } from 'react-icons/tb';
import { IoIosStats } from 'react-icons/io';
import { GrMapLocation, GrUserAdmin } from 'react-icons/gr';

import { HiOutlineBuildingOffice } from 'react-icons/hi2';
import { LiaHistorySolid, LiaUsersCogSolid, LiaUserSecretSolid } from 'react-icons/lia';
import {
  LuCalendarClock,
  LuCalendarCog,
  LuCalendarRange,
  LuCalendarSync,
  LuCalendarX,
  LuChartArea,
  LuChartNoAxesCombined
} from 'react-icons/lu';
import { BsBuildingGear, BsHouseExclamation, BsHouseGear, BsSpeedometer2 } from 'react-icons/bs';
import { MdOutlineSick } from 'react-icons/md';
import { VscTypeHierarchySub } from 'react-icons/vsc';
import {
  PiCalendarXLight,
  PiOfficeChair,
  PiOfficeChairBold,
  PiUsersThree,
  PiUsersThreeBold
} from 'react-icons/pi';
import { SlMap } from 'react-icons/sl';
import { IoCalendarNumberOutline, IoCalendarOutline } from 'react-icons/io5';
import { IoKeyOutline } from 'react-icons/io5';
import { RxDashboard } from 'react-icons/rx';
import { FaHouseCircleExclamation } from 'react-icons/fa6';

const { getHeight, on } = DOMHelper;

const NavItem = props => {
  const { title, eventKey, ...rest } = props;
  return (
    <Nav.Item
      // style={{ color: 'var(--rs-text-secondary)' }}
      eventKey={eventKey}
      as={NavLink}
      {...rest}
    >
      {title}
    </Nav.Item>
  );
};

export interface NavItemData {
  eventKey: string;
  title: string;
  icon?: any;
  to?: string;
  target?: string;
  children?: NavItemData[];
}

export interface FrameProps {
  navs: NavItemData[];
  children?: React.ReactNode;
}

interface Feature {
  id: number;
  name: string;
  sections: Section[];
}

interface Section {
  id: number;
  name: string;
  route: string;
}

const Frame = props => {
  const { selectedFeature, setSelectedFeature } = props;

  const navigate = useNavigate();

  const renderFeature = feature => ({
    ...feature,
    icon: feature?.icon,
    sections: feature?.sections?.map(section => ({
      ...section,
      icon: section?.icon
    }))
  });

  const [expand, setExpand] = useState(false);
  const [windowHeight, setWindowHeight] = useState(getHeight(window));
  const [theme, setTheme] = useState<any>('light');
  const { t } = useTranslation();
  const features = useAppSelector(state => state.feature.data);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (projects.length > 0) {
      const storedFeature = localStorage.getItem('module');

      try {
        if (storedFeature) {
          const parsedFeature = JSON.parse(storedFeature);

          if (parsedFeature && typeof parsedFeature === 'object') {
            const feature = projects.find((item: any) => item.value == parsedFeature?.value);
            setSelectedFeature(renderFeature(feature));
          } else {
            throw new Error('Invalid JSON structure');
          }
        } else {
          const defaultFeature = projects.find(
            (item: any) => item.value === 'organizationSettings'
          );
          if (defaultFeature) {
            localStorage.setItem('module', JSON.stringify(defaultFeature));
            setSelectedFeature(defaultFeature);
          }
        }
      } catch (error) {
        console.error('Error parsing storedFeature:', error);
      }
    }
  }, [projects]);

  const handleFeatureChange = feature => {
    // setSelectedFeature(feature);
    if (feature == 'travel') {
      window.location.href = `${
        process.env.REACT_APP_FLEX_URL
      }admin?token=${getToken()}&refreshToken=${getRefreshToken()}`;
      return;
    }

    const featureObject: any = projects.find((item: any) => item.value == feature);
    setSelectedFeature(featureObject);

    localStorage.setItem('module', JSON.stringify(featureObject));
  };

  const renderSections = () => {
    if (!selectedFeature) return null;

    return (
      <Nav>
        {selectedFeature?.sections?.map(item => {
          const { children, ...rest } = item;
          if (children) {
            return (
              <Nav.Menu
                key={rest.eventKey}
                placement="rightStart"
                trigger="hover"
                {...rest}
                id={rest.eventKey}
                eventKey={rest.eventKey}
              >
                {children.map(child => {
                  return (
                    <NavItem
                      key={child.eventKey}
                      id={child.eventKey}
                      eventKey={child.eventKey}
                      {...child}
                    />
                  );
                })}
              </Nav.Menu>
            );
          }

          if (rest.target === '_blank') {
            return (
              <Nav.Item key={item.eventKey} {...rest}>
                {item.title}
              </Nav.Item>
            );
          }

          return <NavItem key={rest.eventKey} {...rest} />;
        })}
      </Nav>
    );
  };

  useEffect(() => {
    setWindowHeight(getHeight(window));
    const resizeListenner = on(window, 'resize', () => setWindowHeight(getHeight(window)));

    return () => {
      resizeListenner.off();
    };
  }, []);

  useEffect(() => {
    const storedTheme =
      localStorage.getItem('theme') != null ? localStorage.getItem('theme') : theme;
    setTheme(storedTheme);
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  const containerClasses = classNames('page-container', {
    'container-full': !expand
  });

  // const navBodyStyle: React.CSSProperties = expand
  //   ? { height: windowHeight - 112, overflow: 'auto', paddingTop: 30 }
  //   : { paddingTop: 30 };

  const navBodyStyle: React.CSSProperties = expand
    ? { overflow: 'auto', paddingTop: 30 }
    : { paddingTop: 30 };

  useEffect(() => {
    const featuresArray: any = [
      {
        value: 'organizationSettings',
        label: t('Members & Organization settings'),
        name: 'Members & Organization settings',
        icon: <Icon as={PiUsersThreeBold} />,
        color: '#dca704',
        sections: [
          {
            eventKey: 'members',
            icon: <Icon as={PiUsersThree} />,
            title: t('Members'),
            to: '/membersList'
          },
          {
            eventKey: 'members-schedule',
            title: t('Schedules'),
            icon: <Icon as={VscCalendar} />,
            to: '/members-schedule'
          },

          // {
          //   eventKey: 'support',
          //   title: t('Support requests'),
          //   to: '/table-support',
          //   icon: <Icon as={MdOutlineContactSupport} />
          // },
          {
            eventKey: 'support',
            title: t('Other Support Request'),
            to: '/table-support-other',
            icon: <Icon as={MdOutlineContactSupport} />
          },

          {
            eventKey: 'teams',
            title: t('Teams'),
            to: '/department',
            icon: <Icon as={BsBuildingGear} />
          },
          {
            eventKey: 'grade',
            title: t('Grades'),
            to: '/grade',
            icon: <Icon as={VscTypeHierarchySub} />
          }
        ]
      }
    ];

    const onSiteSections = [
      {
        eventKey: 'floorMaps',
        title: t('Real time maps'),

        icon: <Icon as={SlMap} />,
        to: '/floor-maps'
      },

      {
        eventKey: 'resourcesSchedule',
        title: t('Resources schedule'),

        icon: <Icon as={VscCalendar} />,
        to: '/ressources-schedule'
      },

      {
        eventKey: 'onsite',
        title: t('Reservations'),
        icon: <Icon as={Location} />,
        to: '/table-onsite'
      },
      {
        eventKey: 'supportFlex',
        title: t('Flex office Support Request'),
        icon: <Icon as={MdOutlineContactSupport} />,
        to: '/flex-support'
      },
      {
        eventKey: 'workspaces',
        title: t('Workspaces'),
        icon: <Icon as={BsBuildingGear} />,
        to: '/workspaces'
      },
      {
        eventKey: 'access',
        title: t('Accesses'),
        icon: <Icon as={GrUserAdmin} />,
        to: '/access',
        children: [
          {
            eventKey: 'access-profiles',
            title: t('Access profiles'),
            to: '/access-profiles'
          },
          {
            eventKey: 'individual-access',
            title: t('Individual accesses'),
            to: '/individual-access'
          }
        ]
      }
    ];

    const wfhSections = [
      {
        eventKey: 'wfh',
        title: t('Home office Requests'),
        to: '/table-wfh',
        icon: <Icon as={RiHomeOfficeLine} />
      },
      {
        eventKey: 'exceptional-wfh',
        title: t('Exceptional Home office Requests'),
        to: '/exceptional-wfh',
        icon: <Icon as={BsHouseExclamation} />
      },
      {
        eventKey: 'wfh-planning',
        title: t('Home Office Planning'),
        to: '/wfh-planning',
        icon: <Icon as={IoCalendarOutline} />
      },
      {
        eventKey: 'wfhSupport',
        title: t('Home Office and Third Party Site Support Request'),
        to: '/table-supportWFH',
        icon: <Icon as={MdOutlineContactSupport} />
      },

      {
        eventKey: 'wfhBalances',
        title: t('Home office Balances'),
        to: '/table-wfhBalances',
        icon: <Icon as={BsSpeedometer2} />
      },
      {
        eventKey: 'thirdPartySite',
        title: t('Third Party Site Requests'),
        to: '/table-thirdPartySite',
        icon: <Icon as={RiUserLocationLine} />
      },
      // {
      //   eventKey: 'thirdPartySiteSupport',
      //   title: t('Third Party Site Support Request'),
      //   to: '/support-thirdPartySite',
      //   icon: <Icon as={MdOutlineContactSupport} />
      // },
      {
        eventKey: 'wfhProfiles',
        title: t('Home office Profiles'),

        icon: <Icon as={BsHouseGear} />,
        to: '/wfhProfiles'
      }
    ];

    const leaveSections = [
      {
        eventKey: 'holidays',
        title: t('Holidays'),
        to: '/table-holidays',
        icon: <Icon as={RiCalendarCloseLine} />
      },
      {
        eventKey: 'leave-types',
        title: t('Leave types'),
        to: '/leave-types',
        icon: <Icon as={EventDetail} />
      },

      // {
      //   eventKey: 'monthlyLeaveIncrement',
      //   title: t('Monthly increment'),
      //   to: '/monthly-increment',
      //   icon: <Icon as={IoCalendarNumberOutline} />
      // },
      {
        eventKey: 'leave-requests',
        title: t('Leave Requests'),
        to: '/table-leave-requests',
        icon: <Icon as={Calendar} />
      },
      {
        eventKey: 'leave-support',
        title: t('Leave Support Request'),
        to: '/table-leave-supports',
        icon: <Icon as={MdOutlineContactSupport} />
      },
      {
        eventKey: 'leave-balance',
        title: t('Leave Balance'),
        to: '/table-leave-balance',
        icon: <Icon as={BsSpeedometer2} />
      },
      // {
      //   eventKey: 'sickBalance',
      //   title: 'Sick Balance',
      //   to: '/sick-balance',
      //   icon: <Icon as={MdOutlineSick} />
      // },
      {
        eventKey: 'leave-history',
        title: t('Leave History'),
        to: '/table-leave-history',
        icon: <Icon as={LiaHistorySolid} />
      }
    ];

    const addedFeatures = new Set();

    features?.forEach(project => {
      const featureName = project.name?.toLowerCase();

      if (featureName === 'on site') {
        if (!addedFeatures.has('flexOffice')) {
          featuresArray.push({
            label: t('Flex Office'),
            value: 'flexOffice',
            sections: [...onSiteSections],
            icon: <PiOfficeChairBold />,
            color: '#1e9da0'
          });
          addedFeatures.add('flexOffice');
        }
      }

      if (featureName === 'wfh') {
        if (!addedFeatures.has('remoteWork')) {
          featuresArray.push({
            label: t('Remote Work'),
            value: 'remoteWork',
            sections: [...wfhSections],
            icon: <RiHomeOfficeLine />,
            color: '#1e9da0'
          });
          addedFeatures.add('remoteWork');
        }
      }

      if (featureName === 'leave') {
        if (!addedFeatures.has('Leave')) {
          featuresArray.push({
            label: t('Leave'),
            value: 'leave',
            sections: [...leaveSections],
            icon: <RiCalendarCloseLine />,
            color: '#1e9da0'
          });

          addedFeatures.add('Leave');
        }
      }

      if (featureName === 'travel') {
        if (!addedFeatures.has('travel')) {
          featuresArray.push({
            label: t('Business Travel'),
            value: 'travel',
            icon: <GrMapLocation />,
            color: '#6c396b'
          });
          addedFeatures.add('travel');
        }
      }
    });

    if (!addedFeatures.has('analytics')) {
      featuresArray.push({
        label: t('Analytics'),
        value: 'analytics',
        icon: <FaRegChartBar />,
        color: '#e91e63',
        sections: [
          {
            eventKey: 'dashboards',
            title: t('Dashboards'),
            to: '/dashboards',
            icon: <Icon as={MdOutlineDashboard} />,
            children: [
              {
                eventKey: 'spaces',
                title: t('Spaces'),
                to: '/spaces'
              },
              {
                eventKey: 'team-members',
                title: t('Teams & members'),
                to: '/team-members'
              },
              {
                eventKey: 'dashboard-travel',
                title: t('Business travel'),
                to: '/dashboard-travel'
              }
            ]
          },
          {
            eventKey: 'reporting',
            title: t('Reporting'),
            to: '/reporting',
            icon: <Icon as={LuChartNoAxesCombined} />,
            children: [
              {
                eventKey: 'GlobalWork',
                title: t('Global work modes repartition'),
                to: '/global-workmodes'
              },
              {
                eventKey: 'combinedModes',
                title: t('Members work modes repartition'),
                to: '/table-combinedModes'
                // icon: <Icon as={LuChartNoAxesCombined} />
              },
              {
                eventKey: 'untracedUsers',
                title: t('Untraced Users'),
                to: '/table-untracedUsers'
                // icon: <Icon as={LiaUserSecretSolid} />
              }
            ]
          }
        ]
      });
      addedFeatures.add('analytics');
    }

    // if (!addedFeatures.has('reporting')) {
    //   featuresArray.push({
    //     label: 'Reporting',
    //     value: 'reporting',
    //     icon: <IoIosStats />,
    //     color: '#e91e63',
    //     sections: [
    //       {
    //         eventKey: 'combinedModes',
    //         title: 'Combined Modes',
    //         to: '/table-combinedModes',
    //         icon: <Icon as={LuChartNoAxesCombined} />
    //       },
    //       {
    //         eventKey: 'untracedUsers',
    //         title: 'Untraced Users',
    //         to: '/table-untracedUsers',
    //         icon: <Icon as={LiaUserSecretSolid} />
    //       }
    //     ]
    //   });
    //   addedFeatures.add('reporting');

    //   if (features.find(item => item.name?.toLowerCase() === 'on site')) {
    //     featuresArray[featuresArray.length - 1].sections.push({
    //       eventKey: 'onsite',
    //       title: 'On Site',
    //       to: '/table-onsite',
    //       icon: <Icon as={HiOutlineBuildingOffice} />
    //     });
    //   }
    // }

    setProjects(featuresArray);
  }, [features]);

  return (
    <Container theme={theme} className="frame">
      <Sidebar
        style={{ display: 'flex', flexDirection: 'column' }}
        width={expand ? 200 : 56}
        collapsible
      >
        <Sidenav.Header>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: 10,
              height: 70,
              backgroundColor: !expand ? '#0d47a1' : ''
            }}
            onClick={() => navigate('/')}
          >
            {expand ? <Logo /> : <img width={30} src={Brand} />}
          </div>
        </Sidenav.Header>
        <Sidenav expanded={expand} appearance="subtle" defaultOpenKeys={['2', '3']}>
          <Sidenav.Body style={navBodyStyle}>{renderSections()}</Sidenav.Body>
        </Sidenav>

        <NavToggle expand={expand} onChange={() => setExpand(!expand)} />
      </Sidebar>

      <Container className={containerClasses}>
        <Header
          theme={theme}
          onChangeTheme={setTheme}
          expand={expand}
          projects={projects}
          selectedFeature={selectedFeature}
          handleFeatureChange={handleFeatureChange}
        />
        {/* <div style={{ borderBottom: '2px solid #f2f2f5' }}></div> */}
        <Content style={{ paddingTop: '100px' }}>
          <Outlet />
        </Content>
      </Container>
    </Container>
  );
};

export default Frame;
